module.exports = __webpack_public_path__ + "media/images/contact-background-85ecbdda76180397495f2c28342fece2.jpg";